<template>
  <!-- 
  1.화면ID    : MCF_DP_001
  2.화면명    : 부서관리
  3.작성자    : 윤태영 차장
  4.화면설명  : 부서를 등록,수정,삭제 관리한다. (메뉴 3depth 구조)
               트리구조를 VUE 또는 그리드로 표현하고자 내부 회의 결정
               먼저 그리드로 트리 데이터 표출하고자 작업한 케이스 
               VUE로도 구현진행 중 (손대리 측)
  * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
  -->

  <div class="content-wrap">
    
    <!-- 영업기회ID -->
    <div class="row gx-3">
      <div class="col-md-4 col-sm-12">

        <div class="border h-100">
          <div class="d-flex">
          </div>

          <div class="py-3 px-5 dotline-b">
            <div class="my-2 text-center">
              <ElButton type="codeRegist" @buttonClick="clickRowCRUD('add')"><span class="ic-code-plus"></span> 등록</ElButton>
              <ElButton type="codeRegist" @buttonClick="clickRowCRUD('addChild')"><span class="ic-code-plus"></span> 하위등록</ElButton>
              <ElButton type="codeRegist" @buttonClick="clickRowCRUD('edit')"><span class="ic-code-edit"></span> 수정</ElButton>
              <ElButton type="codeRegist" @buttonClick="clickRowCRUD('delete')"><span class="ic-code-del"></span> 삭제</ElButton>
              <!-- <ElButton type="codeRegist" @buttonClick="excelDown()"><span class="ic-code-down"></span> 다운로드</ElButton> -->
            </div>
          </div>

          <!--TREE 공통컴포넌트-->
          <Tree
            ref="treeRef"
            :menuList="state.treeData"
            :context-menu="true"
            :parent-id="'up_dept_cd'"
            :id="'dept_cd'"
            :id-nm="'dept_nm'"
            :root-val="''"
            @return="r=>getDeptData(r)"
            @addRow="r=>addRow(r)"
            @updateRow="r=>updateRow(r)"
            @deleteRow="r=>deleteRow(r)"
          />
        
        </div>

      </div>
      <div class="col-md-8 col-sm-12">

        <div class="border h-100 p-4">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <ElLabel name="상위부서 코드ID">
                  <template v-slot:end="slotProps">
                    <ElInput :id="slotProps.id" v-model="state.dept.up_dept_cd" />
                  </template>
                </ElLabel>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <ElLabel name="부서 코드ID">
                  <template v-slot:end="slotProps">
                    <ElInput :id="slotProps.id" v-model="state.dept.dept_cd" />
                  </template>
                </ElLabel>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <ElLabel name="메모">
                  <template v-slot:end="slotProps">
                    <ElInput :id="slotProps.id" v-model="state.dept.note" />
                  </template>
                </ElLabel>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <ElLabel name="부서명">
                  <template #end="{id}">
                    <ElInput :id="id" v-model="state.dept.dept_nm" />
                  </template>
                </ElLabel>
                
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <ElLabel name="등록일"/>
                <DatePicker
                :selectDate="state.dpAddDt"
                readonly='read'
                @updateDate="r=>state.dpAddDt = r"
                @return="r=>getDate(r,'add_dt')"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <ElLabel name="기준일"/>
                <DatePicker
                  :selectDate="state.dpStDt"
                  @updateDate="r=>state.dpStDt = r"
                  @return="r=>getDate(r,'std_dt')"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <div class="mb-3">
                  <ElLabel name="활성화/비활성화" />

                  <div class="radio-btn-toggle d-flex">

                    <ElLabel name="활성화" classNm="btn btn-sm flex-fill">
                      <template #start="{id}">
                        <ElRadio
                          :id="id"
                          classNm="btn-check"
                          value="Y"
                          v-model="state.dept.enable_yn"
                        />
                      </template>
                    </ElLabel>


                    <ElLabel name="비활성화" classNm="btn btn-sm flex-fill">
                      <template #start="{id}">
                        <ElRadio
                          :id="id"
                          classNm="btn-check"
                          v-model="state.dept.enable_yn"
                          value="N"
                        />
                      </template>
                    </ElLabel>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-end py-3">
            <ElButton type="primary" @buttonClick="fnItemValidation()">저장</ElButton>
          </div>
          
        </div>

        
      </div>
    </div>


  <!--일괄등로 모달 들어갈 자리(필요없어서 삭제함)-->
  </div>
<ExcelManage
  v-show="false"
  ref="excelManageRef"
/>
</template>
  
<script setup>   
import {reactive,ref, onBeforeMount } from 'vue';

import Tree from '@/components/common/SettingTree.vue';
import DatePicker from '@/components/common/DatePicker';
import ExcelManage from '@/components/common/MCO_EX_001.vue';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import { useCodeStore } from '@/store/code'
import common from '@/js/common';
const codeStore = useCodeStore()
const treeRef = ref();
const addDtRef = ref();
const stDtRef = ref();
const excelManageRef = ref();

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { deptList, deptEdit, deptDelete } from '@/api/dept';

onBeforeMount(async()=>{
  await getDepthList()
})


//변수 선언 영역 
const state = reactive({
    treeData : [],
    name : '',
    type : '',
    msg: '그리드',
    exampleBtn : 'exampleBtn',
    dept : {
    dept_cd : '',
    dept_nm : '',
    up_dept_cd : '',
    note : '',
    add_dt : '',
    std_dt : '',
    enable_yn : ''
    },
    dpAddDt : null,
    dpStDt : null,
    excelList : [],
    searchDepth : ''
  });
 
//부서 리스트 조회
const getDepthList = async() => {
  try {
    setIsLoading(true)
    const res = await deptList()
    state.treeData = [...res.rtn]
  } catch (err) {
    console.error(err)
    alert('부서데이터를 불러오는데 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
}

const fnItemValidation = () =>{
 //let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.
 let msg = "기준일이 입력되지 않았습니다."

 if (!state.dept.std_dt) {  // to executes a event not null condition
   alert(msg)
   //stDtRef.value.focus()
    return false;
  }
 
  // RegClick();
  setDeptEdit(state.dept)
  alert("저장하였습니다.")
}

//부서 수정
// const RegClick = async() =>{
//   try {
//     setIsLoading(true)
//     const res = await deptEdit(state.dept)
//     alert('저장 성공')

//     //재조회
//     await getDepthList()
//   } catch (err) {
//     console.error(err)
//     alert('저장중에 오류가 발생했습니다.')
//   } finally {
//     setIsLoading(false)
//   }
// }

const clickRowCRUD = (status)=>{

  treeRef.value.clickRowCRUD(status)
}

const getDeptData = (dept) => {
  state.dept.dept_cd = dept.dept_cd ? dept.dept_cd : ''
  state.dept.up_dept_cd = dept.up_dept_cd ? dept.up_dept_cd : ''
  state.dept.dept_nm = dept.dept_nm ? dept.dept_nm : ''
  state.dept.enable_yn = dept.enable_yn ? dept.enable_yn : ''
  state.dept.note = dept.note ? dept.note : ''
  state.dept.add_dt = dept.add_dt ? common.dateFormat(new Date(dept.add_dt.replaceAll('KST',''))) : ''
  state.dept.std_dt = dept.std_dt ? common.dateFormat(new Date(dept.std_dt.replaceAll('KST',''))) : ''
  //datePicker 동기화
  state.dpStDt = new Date(state.dept.std_dt.replaceAll('KST',''))
  state.dpAddDt = new Date(state.dept.add_dt.replaceAll('KST',''))
  
}

const addRow = async(row) => {
  if(!row.enable_yn) row.enable_yn = 'Y'
  await setDeptEdit(row)

}


//컨텍스트 메뉴 또는 위 수정버튼을 통해(input text로 부서이름) 수정한 경우
const updateRow = async(row) => {

  let params = {
    dept_cd : row.dept_cd,
    dept_nm : row.dept_nm,
    up_dept_cd : row.up_dept_cd,
    note : row.note,
    enable_yn : row.enable_yn,
    upd_id : userStore.user.employeeId,
    std_dt : row.std_dt
  }

  if(params.std_dt === '' || params.std_dt == undefined || params.std_dt == null){
    let today = new Date()

    let year = today.getFullYear().toString();
    let month = ('0' + (today.getMonth() + 1)).slice(-2);
    let day = ('0' + today.getDate()).slice(-2);

    params.std_dt = year + month + day
  }else{
    let date = new Date(params.std_dt.replace('KST',''))

    let year = date.getFullYear().toString();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);

    params.std_dt = year + month + day
  }

  await setDeptEdit(params)
}

const setDeptEdit = async (params) => {
  //case 1 context menu통한 업뎃 및 추가

  try {
    setIsLoading(true)
    const res = await deptEdit(params)
    await getDepthList()
  } catch (err) {
    console.error(err)
    alert('수정에 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
}

//부서 삭제
const deleteRow = async(row) => {
  //if(confirm('정말 삭제하시겠습니까?')){
    let param = {
      dept_cd : row.dept_cd
    }
    try {
      setIsLoading(true)
      const res = await deptDelete(param)
      await getDepthList()
    } catch (err) {
      if(err.data.code == "0004"){
        alert(err.data.ex_message)
      }else{
        alert('삭제에 실패했습니다.')
      }
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  //}
  
}

//datePicker 선택한 날짜를 부서에 적용 함수
const getDate = (r,type) => {
  if(type == 'add_dt'){
    state.dept.add_dt = r
  }else if(type == 'std_dt'){
    state.dept.std_dt = r
  }
}

//엑셀다운
const excelDown = ()=>{
  let dataList = [...treeRef.value.state.treeData]
  let header = [
    {field: 'depth1',headerName : '부서이름(1단계)'}
  ]

  for(let list of dataList){
    let data = {depth1 : list.data.dept_nm}
    state.excelList.push(data)
    let depth = 1
    if(list.children?.length > 0){
      checkChild(list.children,header,depth)
    }
  }

  excelManageRef.value.excelDownload('부서관리',header,state.excelList)
}

const checkChild = (list,header,depth) =>{
  let key = `depth${(depth+1).toString()}`
  if(header.length == depth){
    header.push({field: `depth${(depth+1).toString()}`,headerName : `부서이름(${(depth+1).toString()}단계)`})
  }
  for(let item of list){
    let data = new Object()
    data[key] = item.data.dept_nm
    state.excelList.push(data)
    if(item.children){
      checkChild(item.children,header,depth+1)
    }
  }
}

// const getRecentDepth = async ()=>{
//   if(await getDepthList()){
//     alert('조회성공')
//   }
// }

//트리 부서검색
const onSearch = () => {
  if(state.searchDepth == ''){

  }else{
    let tmpList = [...state.treeData]

    tmpList = tmpList.filter((item)=>{
      if(item.dept_nm.indexOf(state.searchDepth) >= 0) return item
    })

    for(let i of state.treeData){
      i.clickYn = 'N'
    }
    for(let item of tmpList){
      item.clickYn = 'Y'
      let tmpCd = item.dept_cd
      tmpCd = tmpCd.replaceAll('D',',D')
      let codeList = tmpCd.split(',')
      codeList.splice(0,1)
      treeRef.value.searchItem(codeList)
    }
  }
  
 
}
//상위 코드 찾기
const searchParentCd = (item,openTree)=>{
  if(item.up_dept_cd != ''){
    for(let i of state.treeData){
      if(item.up_dept_cd == i.dept_cd){
        openTree.push(i.dept_cd)
        searchParentCd(i,openTree)
      }
    }
  }
}
</script>
     